import { Out } from "@/infrastructure/frontent/clientMessage"
import { DynamicGridRow } from "../dynamicList/DynamicListTypes"
import { DynamicDataSet } from "./DynamicFormData"

export function correctGridRowBoolean(row: DynamicGridRow) {



    try {
        if ( ! row || !row.detailForm || !row.detailForm.view || row.detailForm.view.length <= 0 ) return row    
    
        for(const detailRow of row.detailForm.view) {
            if ( !detailRow.feldTyp || detailRow.feldTyp !== "CheckTextRight" ) continue
            if ( detailRow.value && ( detailRow.value === true || detailRow.value === "True" || detailRow.value === "true")) {
                detailRow.value = "true"
            } else {
                detailRow.value = "false"                    
            }        
        }

    } catch (e) { 
        Out.noOperation("")
    }

}

export function correctGridRowBooleanDataSet(row: DynamicDataSet) {

    try {
        if ( ! row || !row.view || !row.view || row.view.length <= 0 ) return row    
    
        for(const detailRow of row.view) {
            if ( !detailRow.feldTyp || detailRow.feldTyp !== "CheckTextRight" ) continue
            if ( detailRow.value && ( detailRow.value === true || detailRow.value === "True" || detailRow.value === "true")) {
                detailRow.value = "true"
            } else {
                detailRow.value = "false"                    
            }        
        }

    } catch (e) { 
        Out.noOperation("")
    }

}
    